import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components

// index page sections


import {getStats} from "../../components/helpers/StatsHelpers";
import {SeoHelper} from "../../components/helpers/SeoHelper";

class EndUserLicenseAgreement extends React.Component {
  state = {
    songBookCount: null
  };

  constructor(props) {
    super(props);
    getStats.call(this);
  }

  render() {
    return (
      <>
        <SeoHelper
            uri="/end-user-license-agreement"
            title = "End User Licenese Agreement | The Worship Bible"
            description={"The Worhsip Bible's End User License Agreement."}
        />


        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>end user license agreement</span>
                      </h1>
                      {/*<p className="lead text-white">*/}
                      {/*  The design system comes with four pre-built pages to*/}
                      {/*  help you get started faster. You can change the text and*/}
                      {/*  images and you're good to go.*/}
                      {/*</p>*/}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-primary rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-check-bold" />*/}
                          {/*</div>*/}
                          {/*<div dangerouslySetInnerHTML={this.privacyPolicy} />*/}
                          <Row className="justify-content-center">
                            <p className="description mt-3">
                              <img src={require("../../assets/images/termly-logo.png")} alt="Termly"/>
                            </p>
                          </Row>
                          <div className="WordSection1">
                            <p className="MsoNormal"><b><br/>
                              END USER LICENSE AGREEMENT
                            </b>
                            </p>

                            <p className="MsoNormal"><b>Last updated&nbsp;October 03, 2024</b></p>

                            <p className="MsoNormal">
                              __________ is licensed to You (End-User) by __________, located at __________, __________, __________ __________, __________ (<b>"Licensor"</b>), for use only under the terms of this License Agreement.
                            </p>

                            <p className="MsoNormal">
                              By downloading the Licensed Application from , and any update thereto (as permitted by this License Agreement), You indicate that You agree to be bound by all of the terms and conditions of this License Agreement, and that You accept this License Agreement. referred to in this License Agreement as <b>"Services."</b>
                            </p>

                            <p className="MsoNormal">
                              The parties of this License Agreement acknowledge that the Services are not a Party to this License Agreement and are not bound by any provisions or obligations with regard to the Licensed Application, such as warranty, liability, maintenance and support thereof. __________, not the Services, is solely responsible for the Licensed Application and the content thereof.
                            </p>

                            <p className="MsoNormal">
                              This License Agreement may not provide for usage rules for the Licensed Application that are in conflict with the latest (<b>"Usage Rules"</b>). __________ acknowledges that it had the opportunity to review the Usage Rules and this License Agreement is not conflicting with them.
                            </p>

                            <p className="MsoNormal">
                              __________ when purchased or downloaded through the Services, is licensed to You for use only under the terms of this License Agreement. The Licensor reserves all rights not expressly granted to You. __________ is to be used on devices that operate with .
                            </p>

                            <p className="MsoNormal">
                              &nbsp;
                            </p>

                            <p className="MsoNormal"><b>TABLE OF CONTENTS</b></p>

                            <p className="MsoNormal"><a href="#theapp">1. THE APPLICATION</a></p>
                            <p className="MsoNormal"><a href="#scope">2. SCOPE OF LICENSE</a></p>
                            <p className="MsoNormal"><a href="#techreq">3. TECHNICAL REQUIREMENTS</a></p>
                            <p className="MsoNormal"><a href="#nomaint">4. NO MAINTENANCE AND SUPPORT</a></p>
                            <p className="MsoNormal"><a href="#usergen">5. USER-GENERATED CONTRIBUTIONS</a></p>
                            <p className="MsoNormal"><a href="#contrib">6. CONTRIBUTION LICENSE</a></p>
                            <p className="MsoNormal"><a href="#libility">7. LIABILITY</a></p>
                            <p className="MsoNormal"><a href="#warranty">8. WARRANTY</a></p>
                            <p className="MsoNormal"><a href="#claims">9. PRODUCT CLAIMS</a></p>
                            <p className="MsoNormal"><a href="#legal">10. LEGAL COMPLIANCE</a></p>
                            <p className="MsoNormal"><a href="#contact">11. CONTACT INFORMATION</a></p>
                            <p className="MsoNormal"><a href="#termination">12. TERMINATION</a></p>
                            <p className="MsoNormal"><a href="#thirdparty">13. THIRD-PARTY TERMS OF AGREEMENTS AND BENEFICIARY</a></p>
                            <p className="MsoNormal"><a href="#intel">14. INTELLECTUAL PROPERTY RIGHTS</a></p>
                            <p className="MsoNormal"><a href="#laws">15. APPLICABLE LAW</a></p>
                            <p className="MsoNormal"><a href="#misc">16. MISCELLANEOUS</a></p>

                            <p className="MsoNormal"><b>1. <a name="theapp">THE APPLICATION</a></b></p>

                            <p className="MsoNormal">
                              __________ ("Licensed Application") is a piece of software created to __________ — and customized for mobile devices ("Devices"). It is used to __________.
                            </p>

                            <p className="MsoNormal"><b>2. <a name="scope">SCOPE OF LICENSE</a></b></p>

                            <p className="MsoNormal"><b>3. <a name="techreq">TECHNICAL REQUIREMENTS</a></b></p>

                            <p className="MsoNormal"><b>4. <a name="nomaint">NO MAINTENANCE OR SUPPORT</a></b></p>

                            <p className="MsoNormal">
                              4.1  __________ is not obligated, expressed or implied, to provide any maintenance, technical or other support for the Licensed Application.
                            </p>

                            <p className="MsoNormal">
                              4.2  __________ and the End-User acknowledge that the Services have no obligation whatsoever to furnish any maintenance and support services with respect to the Licensed Application.
                            </p>

                            <p className="MsoNormal"><b>5. <a name="usergen">USER-GENERATED CONTRIBUTIONS</a></b></p>

                            <p className="MsoNormal">
                              The Licensed Application does not offer users to submit or post content. We may provide you with the opportunity to create, submit, post, display, transmit, perform, publish, distribute, or broadcast content and materials to us or in the Licensed Application, including but not limited to text, writings, video, audio, photographs, graphics, comments, suggestions, or personal information or other material (collectively, "Contributions"). Contributions may be viewable by other users of the Licensed Application and through third-party websites or applications. As such, any Contributions you transmit may be treated in accordance with the Licensed Application Privacy Policy. When you create or make available any Contributions, you thereby represent and warrant that:
                            </p>

                            <p className="MsoNormal">
                              1. The creation, distribution, transmission, public display, or performance, and the accessing, downloading, or copying of your Contributions do not and will not infringe the proprietary rights, including but not limited to the copyright, patent, trademark, trade secret, or moral rights of any third party.
                              2. You are the creator and owner of or have the necessary licenses, rights, consents, releases, and permissions to use and to authorize us, the Licensed Application, and other users of the Licensed Application to use your Contributions in any manner contemplated by the Licensed Application and this License Agreement.
                              3. You have the written consent, release, and/or permission of each and every identifiable individual person in your Contributions to use the name or likeness or each and every such identifiable individual person to enable inclusion and use of your Contributions in any manner contemplated by the Licensed Application and this License Agreement.
                              4. Your Contributions are not false, inaccurate, or misleading.
                              5. Your Contributions are not unsolicited or unauthorized advertising, promotional materials, pyramid schemes, chain letters, spam, mass mailings, or other forms of solicitation.
                              6. Your Contributions are not obscene, lewd, lascivious, filthy, violent, harassing, libelous, slanderous, or otherwise objectionable (as determined by us).
                              7. Your Contributions do not ridicule, mock, disparage, intimidate, or abuse anyone.
                              8. Your Contributions are not used to harass or threaten (in the legal sense of those terms) any other person and to promote violence against a specific person or class of people.
                              9. Your Contributions do not violate any applicable law, regulation, or rule.
                              10. Your Contributions do not violate the privacy or publicity rights of any third party.
                              11. Your Contributions do not violate any applicable law concerning child pornography, or otherwise intended to protect the health or well-being of minors.
                              12. Your Contributions do not include any offensive comments that are connected to race, national origin, gender, sexual preference, or physical handicap.
                              13. Your Contributions do not otherwise violate, or link to material that violates, any provision of this License Agreement, or any applicable law or regulation.
                            </p>

                            <p className="MsoNormal">
                              Any use of the Licensed Application in violation of the foregoing violates this License Agreement and may result in, among other things, termination or suspension of your rights to use the Licensed Application.
                            </p>

                            <p className="MsoNormal"><b>6. <a name="contrib">CONTRIBUTION LICENSE</a></b></p>

                            <p className="MsoNormal">
                              You agree that we may access, store, process, and use any information and personal data that you provide following the terms of the Privacy Policy and your choices (including settings).
                            </p>

                            <p className="MsoNormal">
                              By submitting suggestions of other feedback regarding the Licensed Application, you agree that we can use and share such feedback for any purpose without compensation to you.
                            </p>

                            <p className="MsoNormal">
                              We do not assert any ownership over your Contributions. You retain full ownership of all of your Contributions and any intellectual property rights or other proprietary rights associated with your Contributions. We are not liable for any statements or representations in your Contributions provided by you in any area in the Licensed Application. You are solely responsible for your Contributions to the Licensed Application and you expressly agree to exonerate us from any and all responsibility and to refrain from any legal action against us regarding your Contributions.
                            </p>

                            <p className="MsoNormal"><b>7. <a name="libility">LIABILITY</a></b></p>

                            <p className="MsoNormal"><b>8. <a name="warranty">WARRANTY</a></b></p>

                            <p className="MsoNormal">
                              8.1  Licensor warrants that the Licensed Application is free of spyware, trojan horses, viruses, or any other malware at the time of Your download. Licensor warrants that the Licensed Application works as described in the user documentation.
                            </p>

                            <p className="MsoNormal">
                              8.2  No warranty is provided for the Licensed Application that is not executable on the device, that has been unauthorizedly modified, handled inappropriately or culpably, combined or installed with inappropriate hardware or software, used with inappropriate accessories, regardless if by Yourself or by third parties, or if there are any other reasons outside of __________'s sphere of influence that affect the executability of the Licensed Application.
                            </p>

                            <p className="MsoNormal">
                              8.3  You are required to inspect the Licensed Application immediately after installing it and notify __________ about issues discovered without delay by email provided in Contact Information. The defect report will be taken into consideration and further investigated if it has been emailed within a period of __________ days after discovery.
                            </p>

                            <p className="MsoNormal">
                              8.4  If we confirm that the Licensed Application is defective, __________ reserves a choice to remedy the situation either by means of solving the defect or substitute delivery.
                            </p>

                            <p className="MsoNormal">
                              8.5  In the event of any failure of the Licensed Application to conform to any applicable warranty, You may notify the Services Store Operator, and Your Licensed Application purchase price will be refunded to You. To the maximum extent permitted by applicable law, the Services Store Operator will have no other warranty obligation whatsoever with respect to the Licensed Application, and any other losses, claims, damages, liabilities, expenses, and costs attributable to any negligence to adhere to any warranty.
                            </p>

                            <p className="MsoNormal">
                              8.6  If the user is an entrepreneur, any claim based on faults expires after a statutory period of limitation amounting to twelve (12) months after the Licensed Application was made available to the user. The statutory periods of limitation given by law apply for users who are consumers.
                            </p>

                            <p className="MsoNormal"><b>9. <a name="claims">PRODUCT CLAIMS</a></b></p>

                            <p className="MsoNormal">
                              __________ and the End-User acknowledge that __________, and not the Services, is responsible for addressing any claims of the End-User or any third party relating to the Licensed Application or the End-User’s possession and/or use of that Licensed Application, including, but not limited to:
                            </p>

                            <p className="MsoNormal">
                              (i) product liability claims;
                            </p>

                            <p className="MsoNormal">
                              (ii) any claim that the Licensed Application fails to conform to any applicable legal or regulatory requirement; and
                            </p>

                            <p className="MsoNormal">
                              (iii) claims arising under consumer protection, privacy, or similar legislation.
                            </p>

                            <p className="MsoNormal"><b>10. <a name="legal">LEGAL COMPLIANCE</a></b></p>

                            <p className="MsoNormal">
                              You represent and warrant that You are not located in a country that is subject to a US Government embargo, or that has been designated by the US Government as a "terrorist supporting" country; and that You are not listed on any US Government list of prohibited or restricted parties.
                            </p>

                            <p className="MsoNormal"><b>11. <a name="contact">CONTACT INFORMATION</a></b></p>

                            <p className="MsoNormal">
                              For general inquiries, complaints, questions or claims concerning the Licensed Application, please contact:
                            </p>

                            <p className="MsoNormal">
                              __________
                            </p>

                            <p className="MsoNormal">
                              __________
                            </p>

                            <p className="MsoNormal">
                              __________, __________ __________
                            </p>

                            <p className="MsoNormal">
                              __________
                            </p>

                            <p className="MsoNormal">
                              __________
                            </p>

                            <p className="MsoNormal"><b>12. <a name="termination">TERMINATION</a></b></p>

                            <p className="MsoNormal">
                              The license is valid until terminated by __________ or by You. Your rights under this license will terminate automatically and without notice from __________ if You fail to adhere to any term(s) of this license. Upon License termination, You shall stop all use of the Licensed Application, and destroy all copies, full or partial, of the Licensed Application.
                            </p>

                            <p className="MsoNormal"><b>13. <a name="thirdparty">THIRD-PARTY TERMS OF AGREEMENTS AND BENEFICIARY</a></b></p>

                            <p className="MsoNormal">
                              __________ represents and warrants that __________ will comply with applicable third-party terms of agreement when using Licensed Application.
                            </p>

                            <p className="MsoNormal">
                              In Accordance with Section 9 of the "Instructions for Minimum Terms of Developer's End-User License Agreement," subsidiaries shall be third-party beneficiaries of this End User License Agreement and — upon Your acceptance of the terms and conditions of this License Agreement, will have the right (and will be deemed to have accepted the right) to enforce this End User License Agreement against You as a third-party beneficiary thereof.
                            </p>

                            <p className="MsoNormal"><b>14. <a name="intel">INTELLECTUAL PROPERTY RIGHTS</a></b></p>

                            <p className="MsoNormal">
                              __________ and the End-User acknowledge that, in the event of any third-party claim that the Licensed Application or the End-User's possession and use of that Licensed Application infringes on the third party's intellectual property rights, __________, and not the Services, will be solely responsible for the investigation, defense, settlement, and discharge or any such intellectual property infringement claims.
                            </p>

                            <p className="MsoNormal"><b>15. <a name="laws">APPLICABLE LAW</a></b></p>

                            <p className="MsoNormal">
                              This License Agreement is governed by the laws of __________ excluding its conflicts of law rules.
                            </p>

                            <p className="MsoNormal"><b>16. <a name="misc">MISCELLANEOUS</a></b></p>

                            <p className="MsoNormal">
                              16.1  If any of the terms of this agreement should be or become invalid, the validity of the remaining provisions shall not be affected. Invalid terms will be replaced by valid ones formulated in a way that will achieve the primary purpose.
                            </p>

                            <p className="MsoNormal">
                              16.2  Collateral agreements, changes and amendments are only valid if laid down in writing. The preceding clause can only be waived in writing.
                            </p>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}
        
      </>
    );
  }
}

export default EndUserLicenseAgreement;
